webpackJsonp([263791100135453],{

/***/ 98:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  color: ', ';\n  font-family: \'Raleway\', Arial, sans-serif;\n  padding-left: 2px;\n  padding-right: 2px;\n  text-decoration: ', ';\n\n  &:hover {\n    color: ', ';\n  }\n'], ['\n  color: ', ';\n  font-family: \'Raleway\', Arial, sans-serif;\n  padding-left: 2px;\n  padding-right: 2px;\n  text-decoration: ', ';\n\n  &:hover {\n    color: ', ';\n  }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _main = __webpack_require__(10);
	
	var _styledComponents = __webpack_require__(8);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Link = _styledComponents2.default.a(_templateObject, _main.colors.lightGrey, function (props) {
	  return props.noUnderline ? 'none' : 'inheirit';
	}, _main.colors.white);
	
	var ExternalLink = function ExternalLink(_ref) {
	  var noUnderline = _ref.noUnderline,
	      href = _ref.href,
	      children = _ref.children;
	
	  return _react2.default.createElement(
	    Link,
	    { noUnderline: noUnderline, href: href, target: '_blank' },
	    children
	  );
	};
	
	exports.default = ExternalLink;
	module.exports = exports['default'];

/***/ }),

/***/ 99:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.Column = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  width: 43%;\n  margin: 0 4%;\n  display: inline-block;\n\n  &:first-of-type {\n    margin-left: 0;\n  }\n\n  @media (max-width: ', ') {\n    width: 100%;\n    margin: 0;\n  }\n'], ['\n  width: 43%;\n  margin: 0 4%;\n  display: inline-block;\n\n  &:first-of-type {\n    margin-left: 0;\n  }\n\n  @media (max-width: ', ') {\n    width: 100%;\n    margin: 0;\n  }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(8);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _main = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Column = exports.Column = _styledComponents2.default.div(_templateObject, _main.breakPoints.tablet);

/***/ }),

/***/ 100:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.ColumnImage = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  opacity: 0.25;\n  height: 24em;\n  width: 16em;\n  animation: ', ' 1.0s linear;\n\n  @media (max-width: ', ') {\n    display: none;\n  }\n\n  &:hover {\n    opacity: 0.75;\n    transition: opacity 1.0s ease-out;\n  }\n'], ['\n  opacity: 0.25;\n  height: 24em;\n  width: 16em;\n  animation: ', ' 1.0s linear;\n\n  @media (max-width: ', ') {\n    display: none;\n  }\n\n  &:hover {\n    opacity: 0.75;\n    transition: opacity 1.0s ease-out;\n  }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(8);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _main = __webpack_require__(10);
	
	var _keyframes = __webpack_require__(101);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var ColumnImage = exports.ColumnImage = _styledComponents2.default.img(_templateObject, _keyframes.fadeInUp, _main.breakPoints.tablet);

/***/ }),

/***/ 558:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/fence.430fb175.jpg";

/***/ }),

/***/ 252:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _external_link = __webpack_require__(98);
	
	var _external_link2 = _interopRequireDefault(_external_link);
	
	var _main = __webpack_require__(10);
	
	var _card = __webpack_require__(75);
	
	var _card2 = _interopRequireDefault(_card);
	
	var _grid = __webpack_require__(99);
	
	var _images = __webpack_require__(100);
	
	var _fence = __webpack_require__(558);
	
	var _fence2 = _interopRequireDefault(_fence);
	
	var _utils = __webpack_require__(57);
	
	var _styledComponents = __webpack_require__(8);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var About = function About(_ref) {
	  var data = _ref.data;
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      _grid.Column,
	      null,
	      _react2.default.createElement(
	        _card2.default,
	        { title: 'About me' },
	        _react2.default.createElement(
	          'p',
	          null,
	          'I\'ve been a software engineer at ',
	          _react2.default.createElement(
	            _external_link2.default,
	            { noUnderline: true, href: 'https://www.greenhouse.io' },
	            'Greenhouse'
	          ),
	          ' since 2014. I started on our test automation team, where I learned the ins and outs of unit and integration testing over a Rails app. Within a year, I earned a promotion to the product engineering team, where I built full-stack features and fixed bugs, in Rails, Postgres and React/Webpack.'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'I\'m now on our DevOps team, where I work on tooling for deployments, buildpacks and autoscaling. My main tech is Kubernetes, Terraform, Argo, Golang and scripting.'
	        ),
	        !(0, _utils.isMobile)() && _react2.default.createElement(
	          'p',
	          null,
	          'I am a graduate of Fullstack Academy of Code, an immersive coding bootcamp based in NYC. Before my transition to programming, I earned a master\'s degree in international affairs and economics from Columbia University.'
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _grid.Column,
	      null,
	      _react2.default.createElement(_images.ColumnImage, { title: 'image by ig: @sofiography', src: _fence2.default })
	    )
	  );
	};
	
	exports.default = About;
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-about-js-c3a6372e1d742d16c2c2.js